import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getConfigurationTemplateConfigTree } from '@api/configurationTemplates';

import { convertToMavenirFlatTreeData } from '@utils/treeFormatter/treeFormatter';

import { TDumpIdPath } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { IPartialOnSuccess } from '@interfaces/common/handlers';
import { IFlatMoTreeNode, IMoTreeResponse } from '@interfaces/components/tree';

import { EUserRoles } from '@enums/common';

import { CONFIGURATION_TEMPLATES_CONFIG_TREE } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesConfigTreeReturned {
	isLoadingConfigTree: boolean;
	generateTree: UseMutateFunction<IMoTreeResponse, any, {dumpId: string; path: string}, any>;
	generatedTree: IFlatMoTreeNode[];
}

type TUseMutateConfigurationTemplatesConfigTree =
	Partial<IPartialOnSuccess<(data: IFlatMoTreeNode[], params: string[]) => void>>

const useMutateConfigurationTemplatesConfigTree = ({
	onSuccess,
}: TUseMutateConfigurationTemplatesConfigTree): IUseQueryConfigurationTemplatesConfigTreeReturned => {
	const {
		data,
		mutate: generateTree,
		isLoading: isLoadingGenerateTree,
	} = useMutation<TDumpIdPath, IMoTreeResponse>({
		mutationFn: getConfigurationTemplateConfigTree,
		onSuccess: (data) => {
			if (onSuccess) {
				const config = data
					? convertToMavenirFlatTreeData({
						data: data ? [data.moTree] : [],
						isSingleSelectMode: true,
						isDefaultNodeChecked: true,
					})
					: [];

				onSuccess(config, []);
			}
		},
		mutationKey: [CONFIGURATION_TEMPLATES_CONFIG_TREE],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	const generatedTree = data
		? convertToMavenirFlatTreeData({
			data: data ? [data.moTree] : [],
			isSingleSelectMode: true,
			isDefaultNodeChecked: true,
		}) : [];

	return {
		generatedTree,
		isLoadingConfigTree: isLoadingGenerateTree,
		generateTree,
	};
};

export default useMutateConfigurationTemplatesConfigTree;
